package navigation.home.task

import navigation.home.task.addedittask.AddEditTaskScreenModel
import navigation.home.task.alltasks.AllTasksScreenModel
import org.koin.dsl.module

val taskUiModule
    get() =
        module {
            factory {
                AllTasksScreenModel(
                    taskRepository = get(),
                    itineraryRepository = get(),
                    categoryRepository = get(),
                    profileRepository = get(),
                    updateTaskUseCase = get(),
                    loadingManager = get()
                )
            }

            factory {
                AddEditTaskScreenModel(
                    taskRepository = get(),
                    itineraryRepository = get(),
                    profileRepository = get(),
                    addTaskUseCase = get(),
                    updateTaskUseCase = get(),
                    getCurrentUserUseCase = get(),
                    loadingManager = get()
                )
            }
        }
